import { Injectable } from '@angular/core';
import { GetAllResponse } from '../model/restful-api.model';
import { environment } from 'src/environments/environment';
import { API_URL } from '../enums/api-enums';
import { ISUPPLIER } from '../model/iSupplier.model';
import { TicketRequest } from '../model/ticket-access-request.model';
import { Observable } from 'rxjs';
import { UtilitiesService } from 'src/app/core/services/utilities.service';

@Injectable({
  providedIn: 'root'
})

export class IsupplierService {

  constructor(private utilities: UtilitiesService) { }

  requestIsupplierAccess(body): Observable<GetAllResponse<ISUPPLIER>> {
    const url = environment.portalURL + API_URL.ISUPPLIER_REQUEST_URL;
    return this.utilities.req.httpPost<GetAllResponse<ISUPPLIER>>(url, body);
  }

  getRequestIsupplierAccess(id): Observable<GetAllResponse<ISUPPLIER>> {
    const url = environment.portalURL + API_URL.ISUPPLIER_REQUEST_URL + `/${id}`;
    return this.utilities.req.httpGet<GetAllResponse<ISUPPLIER>>(url);
  }

  getRequestIsupplierAccessList(): Observable<GetAllResponse<TicketRequest>> {
    const url = environment.portalURL + API_URL.ISUPPLIER_REQUEST_URL;
    return this.utilities.req.httpGet<GetAllResponse<TicketRequest>>(url);
  }

  getSSOList(body): Observable<GetAllResponse<TicketRequest>> {
    const url = environment.portalURL + API_URL.SSO_URL + `?firstName=${body.firstName}&lastName=${body.lastName}&email=${body.email}`;
    return this.utilities.req.httpGet<GetAllResponse<TicketRequest>>(url);
  }

}
